import { useState, useEffect } from 'react';
import { proposalService } from '../../../services/proposal.service';
import type { Proposal } from '../../../services/proposal.service';

export function useProposals(limit = 20) {
  const [searchTerm, setSearchTerm] = useState('');
  const [proposals, setProposals] = useState<Proposal[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [selectedProposal, setSelectedProposal] = useState<Proposal | null>(null);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);

  const fetchProposals = async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await proposalService.listProposals({
        page,
        limit,
        q: searchTerm.trim() || undefined,
      });
      setProposals(data.proposals || []);
      setTotalPages(data.pages || 1);
      setTotalItems(data.total || 0);
    } catch (err: any) {
      setError(err.message || 'An error occurred while fetching proposals.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const debounceTimer = setTimeout(() => {
      fetchProposals();
    }, 300);

    return () => clearTimeout(debounceTimer);
  }, [searchTerm, page, limit]);

  const handleSearchChange = (term: string) => {
    setSearchTerm(term);
    setPage(1);
  };

  return {
    searchTerm,
    proposals,
    loading,
    error,
    selectedProposal,
    setSelectedProposal,
    page,
    setPage,
    totalPages,
    totalItems,
    handleSearchChange,
    refresh: fetchProposals,
  };
}
